module.exports = __webpack_public_path__ + "img/bas.35a4cd9.svg";